export class StopSession{
    forceStop : boolean;
    reason: string;
    //chargePointSessionId : number;
}